import { HttpClient } from '@angular/common/http';
import { Component, Input } from '@angular/core';
import * as Highcharts from 'highcharts';
import HC_accessibility from 'highcharts/modules/accessibility';
import { UniqueChartService } from '../../unique-chart.service';
import Stock from 'highcharts/modules/stock';
import { Observable, Subscription } from 'rxjs';
import { CustomsnapshotService } from 'src/app/modules/snapshot/Services/customsnapshot.service';
import { COMMON_CONSTANTS, COMMON_CONSTANTS_Percentage, COMMON_CONSTANTS_SNAPSHOT } from 'src/app/common/constants/common-constants';
import { SnapshotService } from 'src/app/modules/snapshot/Services/snapshot.service';
import { BarserviceService } from '../../../../barchart/barchart/barservice.service';
import { ActivatedRoute } from '@angular/router';

Stock(Highcharts);
@Component({
  selector: 'app-funnelchart1-custom',
  templateUrl: './funnelchart1.component.html',
  styleUrls: [],
})
export class Funnelchart1ComponentCustom {
  constructor(
    private http: HttpClient,
    private uniquechartservice: UniqueChartService,
    private _customSnapshotService: CustomsnapshotService,
    public _configService: SnapshotService,
    private barService: BarserviceService,
    private route: ActivatedRoute,
  ) { }

  jsondata: any;
  seriescolor: any;
  seriesgradientcolor: any;
  chartproperties: any;
  samplesizeconstant: any;

  //parameters from snapshot-chrtparent
  @Input() gridTempleteColumns: any;
  @Input() popUpp: any;
  @Input() popUp: any;
  @Input() customData: any;
  @Input() id: any = 0;
  @Input() sort: any;
  @Input() WidgetDetails: any;
  @Input() height: any = "24em";
  @Input() isOutput: any;
  @Input() showXaxisLabels: boolean = true;
  @Input() multiFunnelPopup: boolean = false;
  maxDataPoints: any = 2;
  significanceValue: any = "None";
  chartMainData: any = [];
  Sig_LowerLimt = COMMON_CONSTANTS.SigLowerLimit_95;
  Sig_UpperLimt = COMMON_CONSTANTS.SigUpperLimit_95;
  DefaultConfidenceLevel: any = "";
  // ngOnInit(): void {
  //   this.http.get<any>('assets/Data/piechart.json').subscribe((data) => {
  //     this.jsondata = data[0];
  //     this.chartproperties = this.jsondata['properties'][0];
  //     this.chartproperties.decimalRoundOff=2;
  //     this.seriescolor = this.uniquechartservice.color;
  //     this.seriesgradientcolor = this.uniquechartservice.linearGradients1;
  //     this.samplesizeconstant = this.uniquechartservice.samplesizeconstant;
  //     this.plotChart(
  //       'chart-container'+this.id,
  //       this.jsondata['data'],
  //       this.chartproperties
  //     );
  //   });
  // }
  private subscriptions: Subscription = new Subscription();
  configuredProperties: any;
  userselectedchartdata: any;
  ngOnInit(): void {
    if (this.isOutput) {
      this.configuredProperties = JSON.parse(this.customData.customizationProperties);
      this.customData = this.customData.metric[0];
      this.customData.metric_value.sort((a: any, b: any) => a.selectorder - b.selectorder);
      this.maxDataPoints = this.popUp ? 6 : this.maxDataPoints;
      this.subscriptions.add(
        this._configService.confedenceValue.subscribe(value => {
          this.DefaultConfidenceLevel = value;
          this.updateSig();
        }));
      this.subscriptions.add(
        this._configService.significanceValue.subscribe(value => {
          this.significanceValue = value;
          this.updateSig();
        }));
      if (!this.multiFunnelPopup) {
        this._customSnapshotService.getSelectedBrand(this.id).subscribe((selectedBrand) => {
          this.selectedBrand = selectedBrand;
          if (this.selectedBrand != undefined || this.selectedBrand != "") {
            this.plotChart(
              'chart-container' + this.id,
              this.customData,
              this.chartproperties
            );
          }
        });
      }
    }
    else {
      this.http.get<any>('assets/Data/funnelchartData.json').subscribe((data) => {
        console.log("funnelchartcustomdata", this.customData);
        this.jsondata = data[0];
        this.chartproperties = this.jsondata['properties'][0];
        this.chartproperties.decimalRoundOff = 2;
        this.seriescolor = this.uniquechartservice.color;
        this.seriesgradientcolor = this.uniquechartservice.linearGradients1;
        this.samplesizeconstant = this.uniquechartservice.samplesizeconstant;
        this.route.paramMap.subscribe((params) => {
          const userData = history.state.userData;
          this.userselectedchartdata = userData; // Use the userData object as needed
          if (this.userselectedchartdata?.widgetEditSelection) {
            if (this.userselectedchartdata?.widgetEditSelection?.customizationProperties != "") {
              this.chartproperties = JSON.parse(this.userselectedchartdata?.widgetEditSelection?.customizationProperties);
            }
          }
        });
        this.plotChart(
          'chart-container' + this.id,
          this.jsondata['data'],
          this.chartproperties
        );
      });
    }

  }

  updateSig() {
    this.subscriptions.add(
      this.http.get<any>('assets/Data/funnelchartData.json').subscribe((data) => {
        this.customData.metric_value.sort((a: any, b: any) => a.selectorder - b.selectorder);
        this.jsondata = data[0];
        this.chartproperties = this.jsondata['properties'][0];
        this.chartproperties = this.configuredProperties != undefined ? this.configuredProperties : this.chartproperties;
        this.seriescolor = this.uniquechartservice.color;
        this.seriesgradientcolor = this.uniquechartservice.linearGradients1;
        this.samplesizeconstant = this.uniquechartservice.samplesizeconstant;
        this.chartproperties.datalabelStyle = this.significanceValue == "None" ? "datalabel" : "sigChange";
        this.chartproperties.dataLabelPosition = 'right';
        this.chartproperties.datalabelStyle = this._configService.isIndexSelected ? "index" : this.chartproperties.datalabelStyle;
        this.Sig_LowerLimt =
          this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_95
            ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_95
            : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_90
              ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_90
              : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_99
                ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_99
                : COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_95;
        this.Sig_UpperLimt =
          this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_95
            ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_95
            : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_90
              ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_90
              : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_99
                ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_99
                : COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_95;
        this.plotChart(
          'chart-container' + this.id,
          this.jsondata['data'],
          this.chartproperties
        );
      }));
  }

  @Input() selectedBrand: any = "";
  brandList: any = [];
  preparemainChartData(data: any) {
    this.chartMainData = [];
    // this.chartproperties=this.configuredProperties!=undefined?this.configuredProperties:this.chartproperties;
    let i = 0;
    if (this._configService.selectedSnapshotType.toLowerCase().includes('multi')) {

      this.brandList = [];
      data.metric_value[0].data.forEach((d: any) => {
        this.brandList.push(d.colChild);
      })
      if (this.brandList.length > 0) {
        if (this.selectedBrand == undefined || this.selectedBrand == "") { this.selectedBrand = this.brandList[0]; }
        this._customSnapshotService.updateBrandList(this.id, this.brandList, this.selectedBrand);
      }

      data.metric_value.forEach((lev2: any) => {
        lev2.data.forEach((dataArr: any) => {
          if (dataArr.colChild == this.selectedBrand) {
            let d1 = {
              "Series Name": lev2.option,
              "Category Name": lev2.metric_group,
              "Rounded Value": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
              "Value": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
              "ValueForIndex": (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
              "ActualIndexValue": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == null) ? null : (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
              "Label": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
              "Change value vs PY": dataArr.changeVsPY,
              "Significance": "-1",
              "Sample size": dataArr.baseValueforLSorIs,
              "Significance2": "1",
              "isPercentage": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? true : false,
              "Sig_LowerLimt": this.Sig_LowerLimt,
              "Sig_UpperLimt": this.Sig_UpperLimt,
              "Significance_Value": dataArr.Significance_Value
            }
            this.chartMainData.push(d1);
          }
        });
      });
    }
    else {
      data.metric_value.forEach((lev2: any) => {
        lev2.data.forEach((dataArr: any) => {
          let d1 = {
            "Series Name": lev2.option,
            "Category Name": lev2.metric_group,
            "Rounded Value": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
            "Value": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
            "ValueForIndex": (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
            "ActualIndexValue": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == null) ? null : (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
            "Label": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
            "Change value vs PY": dataArr.changeVsPY,
            "Significance": "-1",
            "Sample size": dataArr.baseValueforLSorIs,
            "Significance2": "1",
            "isPercentage": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? true : false,
            "Sig_LowerLimt": this.Sig_LowerLimt,
            "Sig_UpperLimt": this.Sig_UpperLimt,
            "Significance_Value": dataArr.Significance_Value
          }
          this.chartMainData.push(d1);
        });
      });
    }

  }

  customization(): Observable<any[]> { //"Funnel Chart "
    // let custom = this.uniquechartservice.FunnelChartCustomizationList();
    // return custom;
    return this._customSnapshotService.getChartCustomization("Funnel Chart ", this._customSnapshotService.selectedSnapshotType?.name);
  }

  arrangeArrayDescending(data: any[]): any[] {
    data.sort((a, b) => {
      const valueA = parseFloat(a['Rounded Value']);
      const valueB = parseFloat(b['Rounded Value']);

      // Handle null values
      if (isNaN(valueA) && isNaN(valueB)) {
        return 0; // Both are null, keep their relative order
      }
      if (isNaN(valueA)) {
        return 1; // Null should come after any number
      }
      if (isNaN(valueB)) {
        return -1; // Null should come after any number
      }

      // Handle 0 values
      if (valueA === 0 && valueB === 0) {
        return 0; // Both are 0, keep their relative order
      }
      if (valueA === 0) {
        return 1; // 0 should come after any other number
      }
      if (valueB === 0) {
        return -1; // 0 should come after any other number
      }

      // Sort in descending order of Rounded Value
      return valueB - valueA;
    });

    return data;
  }

  chart: any;
  seriesdata: any;
  xaxis: any = [];
  // preparechartdata(data: any, islowsample: any, isgradient: any) {
  //   let seriesdata: any[] = [];
  //   let xaxis: any = [];
  //   let i = 0;
  //   let data1 = this.arrangeArrayDescending(data);
  //   let maxdatapoint = parseFloat(data1[0]['Rounded Value']);
  //   let series1: any = {
  //     name: 'Other',
  //     data: [],
  //     borderWidth: 0,
  //     shadow: false,
  //   };
  //   let series2: any = {
  //     name: data[0]['Series Name'],
  //     data: [],
  //   };
  //   let series3: any = {
  //     name: 'Other',
  //     data: [],
  //     borderWidth: 0,
  //     shadow: false,
  //   };
  //   data1.forEach((dat: any) => {
  //     let value =
  //       isNaN(parseFloat(dat['Value'])) ||
  //       parseFloat(dat['Value']) == null
  //         ? null
  //         : parseFloat(dat['Value']);
  //     let finalvalue = !islowsample
  //       ? value
  //       : parseFloat(dat['Sample size']) > this.samplesizeconstant
  //       ? value
  //       : 0;
  //     xaxis.push(dat['Series Name']);
  //     let s1 = {
  //       name: 'Others',
  //       y: (maxdatapoint - (finalvalue == null ? 0 : finalvalue)) / 2,
  //       color: 'transparent',
  //       dataLabels: { enabled: false },
  //     };
  //     let s2 = {
  //       name: dat['Series Name'],
  //       y:  Number(parseFloat(finalvalue == null ? '0' : finalvalue.toString()).toFixed(this.chartproperties.decimalRoundOff)),
  //       y1: Number(parseFloat(finalvalue == null ? '0' : finalvalue.toString()).toFixed(this.chartproperties.decimalRoundOff)),
  //       actualcolor:this.seriescolor[i],
  //       color: !isgradient
  //         ? this.seriescolor[i++]
  //         : this.seriesgradientcolor[i++],
  //       samplesize: dat['Sample size'],
  //       cov: dat['Change value vs PY'],
  //       significance: dat['Significance'],
  //       significance2: dat['Significance2'],
  //       tooltip: '',
  //     };
  //     let s3 = {
  //       name: 'Others',
  //       y: (maxdatapoint - (finalvalue == null ? 0 : finalvalue)) / 2,
  //       color: 'transparent',
  //       dataLabels: { enabled: false },
  //     };
  //     series1.data.push(s1);
  //     series2.data.push(s2);
  //     series3.data.push(s3);
  //   });
  //   seriesdata = [series1, series2, series3];
  //   this.seriesdata = seriesdata;
  //   this.xaxis = xaxis;
  // }

  preparechartdata(data: any, islowsample: any, isgradient: any) {
    if (this.isOutput) {
      let seriesdata: any[] = [];
      let xaxis: any = [];
      let i = 0;
      // let data1 = this.arrangeArrayDescending(data);
      let data1 = data;

      const valuesArray = data.map((item: any) => item.Value);
      const valuesArray2 = data.map((item: any) => ({
        value: item.Value != null || NaN
          ? item.Value : 'NA',
        samplesize: item["Sample size"]
      }));
      const valuesArray1 = valuesArray2.map((item: any) =>
        this._configService.CheckLSorIScondition(this._configService.userRole, item.value, item.samplesize)
      );
      // ;
      let diff = valuesArray1.slice(1).map((currentValue: any, index: any) => {
        currentValue = currentValue.toString();
        let previousValue = valuesArray1[index].toString();
        switch (true) {
          case (Math.round(currentValue).toString() === '0' && previousValue.toString() == 'I/S'):
            return '0';
          case (Math.round(currentValue).toString() === '0' && Math.round(previousValue).toString() === '0'):
          case (Math.round(currentValue).toString() === '0' && previousValue.toString() === 'NA'):
          case (currentValue.toString() === 'NA' && Math.round(previousValue).toString() === '0'):
          case (currentValue.toString() === 'NA' && previousValue.toString() === 'I/S'):
            return 'NA';
          case (Math.round(currentValue).toString() === '0' && !isNaN(previousValue.toString())):
          case (Math.round(currentValue).toString() === '0' && previousValue.toString().includes('*')):
            return '0';
          case (currentValue.toString() === 'NA' && !isNaN(previousValue.toString())):
          case (currentValue.toString() === 'NA' && previousValue.toString().includes('*')):
            return 'NA';

          case (currentValue.toString() === 'I/S' && Math.round(previousValue).toString() === '0'):
            return 'NA';
          case (currentValue.toString() === 'I/S' && previousValue.toString() === 'I/S'):
            return 'I/S';

          case (!currentValue.toString().includes("*") && !isNaN(currentValue.toString()) && Math.round(previousValue).toString() === '0'):
          case (currentValue.toString().includes('*') && Math.round(previousValue).toString() === '0'):
          case (currentValue.toString().includes('*') && currentValue.toString().match(/\d+(\.\d+)?/)![0] == "0"):
            return 'NA';

          case (currentValue.toString() === 'I/S' && previousValue.toString() === 'NA'):
            return 'NA';
          case (!currentValue.toString().includes("*") && !isNaN(currentValue.toString()) && previousValue.toString() === 'NA'):
          case (currentValue.toString().includes('*') && previousValue.toString() === 'NA'):
            return 'NA';
          case (currentValue.toString() === 'NA' || previousValue.toString() === 'NA'):
            return 'NA';
          case (!currentValue.toString().includes("*") && !isNaN(currentValue.toString()) && previousValue.toString() === 'I/S'):
            return 'I/S';
          case (currentValue.toString().includes('*') && previousValue.toString() === 'I/S'):
            return 'I/S';
          case (currentValue.toString() === 'I/S' && !isNaN(previousValue.toString())):
            return Number(parseFloat(valuesArray2[index - 1]).toFixed(this.chartproperties.decimalRoundOff)) / Number(parseFloat(previousValue).toFixed(this.chartproperties.decimalRoundOff)) * 100;
          case (currentValue.toString() === 'I/S' && previousValue.toString().includes('*')):
            previousValue = /\d+(\.\d+)?/.test(valuesArray1[index].toString()) ? previousValue.toString().match(/\d+(\.\d+)?/)![0] : previousValue.toString();
            return Number(parseFloat(valuesArray2[index - 1]).toFixed(this.chartproperties.decimalRoundOff)) / Number(parseFloat(previousValue).toFixed(this.chartproperties.decimalRoundOff)) * 100 + "*";
          default:
            currentValue = /\d+(\.\d+)?/.test(currentValue.toString()) ? currentValue.toString().match(/\d+(\.\d+)?/)![0] : currentValue.toString();
            previousValue = /\d+(\.\d+)?/.test(valuesArray1[index].toString()) ? previousValue.toString().match(/\d+(\.\d+)?/)![0] : previousValue.toString();
            let answer = (Number(parseFloat(currentValue).toFixed(this.chartproperties?.decimalRoundOff)) / Number(parseFloat(previousValue).toFixed(this.chartproperties?.decimalRoundOff))) * 100;
            return Number.isNaN(answer) ? "NA" : answer;
        }
        // if (Number(parseFloat(currentValue).toFixed(this.chartproperties.decimalRoundOff)) === 0) {
        //   return 0;
        // } else if (Number(parseFloat(previousValue).toFixed(this.chartproperties.decimalRoundOff)) === 0) {
        //   return "NA";
        // } else {
        //   return (Number(parseFloat(currentValue).toFixed(this.chartproperties.decimalRoundOff)) / Number(parseFloat(previousValue).toFixed(this.chartproperties.decimalRoundOff))) * 100;
        // }
      });

      diff = diff.filter((item: any) => {
        return item != undefined
      })
        
        ;
      let roundedValues = data1.map(function (item: any) {
        return item['Rounded Value'];
      });

      // Find the maximum value

      let maxdatapoint = Math.max.apply(Math, roundedValues)+10;
      let maxdatapoint2 = Math.max(...diff);
      // let maxdatapoint = parseFloat(data1[0]['Rounded Value']);
      let series1: any = {
        name: 'Other',
        data: [],
        borderWidth: 0,
        shadow: false,
        pointPadding: 0.1,
        groupPadding: 0.1,
        // pointWidth:2
      };
      let series2: any = {
        name: data[0]['Series Name'],
        data: [],
        pointPadding: 0.1,
        groupPadding: 0.1,
        // pointWidth:2
      };
      let series3: any = {
        name: 'Other',
        data: [],
        borderWidth: 0,
        shadow: false,
        pointPadding: 0.1,
        groupPadding: 0.1,
        // pointWidth:2
      };
      data1.forEach((dat: any, index: number) => {
        let value =
          isNaN(parseFloat(dat['Rounded Value'])) ||
            parseFloat(dat['Rounded Value']) == null
            ? null
            : Number(parseFloat(dat['Value']).toFixed(this.chartproperties?.decimalRoundOff));
        let finalvalue: any = !islowsample
          ? value
          : parseFloat(dat['Sample size']) > this.samplesizeconstant
            ? value
            : 0;
        xaxis.push(dat['Series Name']);
        let s1 = {
          name: 'Others',
          y: (maxdatapoint - (this._configService.CheckLSorIScondition(this._configService.userRole, finalvalue?.toString(), dat['Sample size']).includes("I/S") || finalvalue == null ? 0 : finalvalue)) / 2 == 0 ? 1000 : (maxdatapoint - (this._configService.CheckLSorIScondition(this._configService.userRole, finalvalue?.toString(), dat['Sample size']).includes("I/S") || finalvalue == null ? 0 : finalvalue)) / 2,
          color: 'transparent',
          dataLabels: { enabled: false },
        };
        let s2 = {
          name: dat['Series Name'],
          y: this._configService.CheckLSorIScondition(this._configService.userRole, finalvalue?.toString(), dat['Sample size']).includes("I/S") || finalvalue == null ? 0 : finalvalue,
          indexValue: this._configService.CheckLSorIScondition(this._configService.userRole, dat['ValueForIndex']?.toString(), dat['Sample size']).includes("I/S") || dat['ValueForIndex'] == null ? 0 : dat['ValueForIndex'],
          actualIndexValue: dat['ActualIndexValue'],
          y1: finalvalue,
          actualcolor: this.seriescolor?.[i],
          conversion: diff[i],
          color: !isgradient
            ? this.seriescolor?.[i]
            : this.seriesgradientcolor[i],
          samplesize: dat['Sample size'],
          cov: dat['Change value vs PY'],
          significance: dat['Significance'],
          significance2: dat['Significance2'],
          tooltip: '',
          isPercentage: dat["isPercentage"],
          Sig_LowerLimt: this.Sig_LowerLimt,
          Sig_UpperLimt: this.Sig_UpperLimt,
          Significance_Value: dat['Significance_Value'],
          isLastSeries: index == data1.length - 1 ? true : false
        };
        let s3 = {
          name: 'Others',
          y: (maxdatapoint - (this._configService.CheckLSorIScondition(this._configService.userRole, finalvalue?.toString(), dat['Sample size']).includes("I/S") || finalvalue == null ? 0 : finalvalue)) / 2 == 0 ? 1000 : (maxdatapoint - (this._configService.CheckLSorIScondition(this._configService.userRole, finalvalue?.toString(), dat['Sample size']).includes("I/S") || finalvalue == null ? 0 : finalvalue)) / 2,
          color: 'transparent',
          dataLabels: { enabled: false },
        };
        series1.data.push(s1);
        series2.data.push(s2);
        series3.data.push(s3);

        if (i < data1.length - 1) {
          let s11 = {
            name: 'Others',
            y: 1000,
            y1: -1,
            color: 'transparent',
            dataLabels: { enabled: false },
            pointWidth: 2,
          };
          let s22 = {
            name: '',
            y: 1000,
            y1: -1,
            actualcolor: 'transparent',
            conversion: diff[i++],
            color: 'transparent',
            samplesize: dat['Sample size'],
            cov: dat['Change value vs PY'],
            significance: dat['Significance'],
            significance2: dat['Significance2'],
            tooltip: '',
            isPercentage: true,
            Sig_LowerLimt: this.Sig_LowerLimt,
            Sig_UpperLimt: this.Sig_UpperLimt,
            Significance_Value: dat['Significance_Value'],
            // dataLabels: { enabled: false },
            pointWidth: 2,
          };
          let s33 = {
            name: 'Others',
            y: 1000,
            y1: -1,
            color: 'transparent',
            dataLabels: { enabled: false },
            pointWidth: 2,
          };

          
          series1.data.push(s11);
          series2.data.push(s22);
          series3.data.push(s33);
          xaxis.push('');
        }

      });
      seriesdata = [series1, series2, series3];
      this.seriesdata = seriesdata;
      this.xaxis = xaxis;
      ;
    }
    else {
      let seriesdata: any[] = [];
      let xaxis: any = [];
      let i = 0;
      // let data1 = this.arrangeArrayDescending(data);
      let data1 = data;

      const valuesArray = data.map((item: any) => item.Value);
      const valuesArray2 = data.map((item: any) => ({
        value: item.Value != null || NaN
          ? item.Value : 'NA',
        samplesize: item["Sample size"]
      }));
      const valuesArray1 = valuesArray2.map((item: any) =>
        this._configService.CheckLSorIScondition(this._configService.userRole, item.value, item.samplesize)
      );
      // ;
      let diff = valuesArray1.slice(1).map((currentValue: any, index: any) => {
        currentValue = currentValue.toString();
        let previousValue = valuesArray1[index].toString();
        switch (true) {
          case (Math.round(currentValue).toString() === '0' && previousValue.toString() == 'I/S'):
            return '0';
          case (Math.round(currentValue).toString() === '0' && Math.round(previousValue).toString() === '0'):
          case (Math.round(currentValue).toString() === '0' && previousValue.toString() === 'NA'):
          case (currentValue.toString() === 'NA' && Math.round(previousValue).toString() === '0'):
          case (currentValue.toString() === 'NA' && previousValue.toString() === 'I/S'):
            return 'NA';
          case (Math.round(currentValue).toString() === '0' && !isNaN(previousValue.toString())):
          case (Math.round(currentValue).toString() === '0' && previousValue.toString().includes('*')):
            return '0';
          case (currentValue.toString() === 'NA' && !isNaN(previousValue.toString())):
          case (currentValue.toString() === 'NA' && previousValue.toString().includes('*')):
            return 'NA';

          case (currentValue.toString() === 'I/S' && Math.round(previousValue).toString() === '0'):
            return 'NA';
          case (currentValue.toString() === 'I/S' && previousValue.toString() === 'I/S'):
            return 'I/S';

          case (!currentValue.toString().includes("*") && !isNaN(currentValue.toString()) && Math.round(previousValue).toString() === '0'):
          case (currentValue.toString().includes('*') && Math.round(previousValue).toString() === '0'):
          case (currentValue.toString().includes('*') && currentValue.toString().match(/\d+(\.\d+)?/)![0] == "0"):
            return 'NA';

          case (currentValue.toString() === 'I/S' && previousValue.toString() === 'NA'):
            return 'NA';
          case (!currentValue.toString().includes("*") && !isNaN(currentValue.toString()) && previousValue.toString() === 'NA'):
          case (currentValue.toString().includes('*') && previousValue.toString() === 'NA'):
            return 'NA';
          case (currentValue.toString() === 'NA' || previousValue.toString() === 'NA'):
            return 'NA';
          case (!currentValue.toString().includes("*") && !isNaN(currentValue.toString()) && previousValue.toString() === 'I/S'):
            return 'I/S';
          case (currentValue.toString().includes('*') && previousValue.toString() === 'I/S'):
            return 'I/S';
          case (currentValue.toString() === 'I/S' && !isNaN(previousValue.toString())):
            return Number(parseFloat(valuesArray2[index - 1]).toFixed(this.chartproperties.decimalRoundOff)) / Number(parseFloat(previousValue).toFixed(this.chartproperties.decimalRoundOff)) * 100;
          case (currentValue.toString() === 'I/S' && previousValue.toString().includes('*')):
            previousValue = /\d+(\.\d+)?/.test(valuesArray1[index].toString()) ? previousValue.toString().match(/\d+(\.\d+)?/)![0] : previousValue.toString();
            return Number(parseFloat(valuesArray2[index - 1]).toFixed(this.chartproperties.decimalRoundOff)) / Number(parseFloat(previousValue).toFixed(this.chartproperties.decimalRoundOff)) * 100 + "*";
          default:
            currentValue = /\d+(\.\d+)?/.test(currentValue.toString()) ? currentValue.toString().match(/\d+(\.\d+)?/)![0] : currentValue.toString();
            previousValue = /\d+(\.\d+)?/.test(valuesArray1[index].toString()) ? previousValue.toString().match(/\d+(\.\d+)?/)![0] : previousValue.toString();
            let answer = (Number(parseFloat(currentValue).toFixed(this.chartproperties?.decimalRoundOff)) / Number(parseFloat(previousValue).toFixed(this.chartproperties.decimalRoundOff))) * 100;
            return Number.isNaN(answer) ? "NA" : answer;
        }
        // if (Number(parseFloat(currentValue).toFixed(this.chartproperties.decimalRoundOff)) === 0) {
        //   return 0;
        // } else if (Number(parseFloat(previousValue).toFixed(this.chartproperties.decimalRoundOff)) === 0) {
        //   return "NA";
        // } else {
        //   return (Number(parseFloat(currentValue).toFixed(this.chartproperties.decimalRoundOff)) / Number(parseFloat(previousValue).toFixed(this.chartproperties.decimalRoundOff))) * 100;
        // }
      });

      diff = diff.filter((item: any) => {
        return item != undefined
      })
        //console.log(diff);
        ;
      let roundedValues = data1.map(function (item: any) {
        return item['Rounded Value'];
      });

      // Find the maximum value

      let maxdatapoint = Math.max.apply(Math, roundedValues)+10;
      let maxdatapoint2 = Math.max(...diff);
      // let maxdatapoint = parseFloat(data1[0]['Rounded Value']);
      let series1: any = {
        name: 'Other',
        data: [],
        borderWidth: 0,
        shadow: false,
        pointPadding: 0.1,
        groupPadding: 0.1,
        // pointWidth:2
      };
      let series2: any = {
        name: data[0]['Series Name'],
        data: [],
        pointPadding: 0.1,
        groupPadding: 0.1,
        // pointWidth:2
      };
      let series3: any = {
        name: 'Other',
        data: [],
        borderWidth: 0,
        shadow: false,
        pointPadding: 0.1,
        groupPadding: 0.1,
        // pointWidth:2
      };
      data1.forEach((dat: any, index: number) => {
        let value =
          isNaN(parseFloat(dat['Rounded Value'])) ||
            parseFloat(dat['Rounded Value']) == null
            ? null
            : Number(parseFloat(dat['Value']).toFixed(this.chartproperties.decimalRoundOff));
        let finalvalue: any = !islowsample
          ? value
          : parseFloat(dat['Sample size']) > this.samplesizeconstant
            ? value
            : 0;
        xaxis.push(dat['Series Name']);
        let s1 = {
          name: 'Others',
          y: (maxdatapoint - (this._configService.CheckLSorIScondition(this._configService.userRole, finalvalue?.toString(), dat['Sample size']).includes("I/S") || finalvalue == null ? 0 : finalvalue)) / 2 == 0 ? 1000 : (maxdatapoint - (this._configService.CheckLSorIScondition(this._configService.userRole, finalvalue?.toString(), dat['Sample size']).includes("I/S") || finalvalue == null ? 0 : finalvalue)) / 2,
          color: 'transparent',
          dataLabels: { enabled: false },
        };
        let s2 = {
          name: dat['Series Name'],
          y: this._configService.CheckLSorIScondition(this._configService.userRole, finalvalue?.toString(), dat['Sample size']).includes("I/S") || finalvalue == null ? 0 : finalvalue,
          indexValue: this._configService.CheckLSorIScondition(this._configService.userRole, dat['ValueForIndex']?.toString(), dat['Sample size']).includes("I/S") || dat['ValueForIndex'] == null ? 0 : dat['ValueForIndex'],
          actualIndexValue: dat['ActualIndexValue'],
          y1: finalvalue,
          actualcolor: this.seriescolor[i],
          conversion: diff[i],
          color: !isgradient
            ? this.seriescolor[i]
            : this.seriesgradientcolor[i],
          samplesize: dat['Sample size'],
          cov: dat['Change value vs PY'],
          significance: dat['Significance'],
          significance2: dat['Significance2'],
          tooltip: '',
          isPercentage: dat["isPercentage"],
          Sig_LowerLimt: this.Sig_LowerLimt,
          Sig_UpperLimt: this.Sig_UpperLimt,
          Significance_Value: dat['Significance_Value'],
          isLastSeries: index == data1.length - 1 ? true : false
        };
        let s3 = {
          name: 'Others',
          y: (maxdatapoint - (this._configService.CheckLSorIScondition(this._configService.userRole, finalvalue?.toString(), dat['Sample size']).includes("I/S") || finalvalue == null ? 0 : finalvalue)) / 2 == 0 ? 1000 : (maxdatapoint - (this._configService.CheckLSorIScondition(this._configService.userRole, finalvalue?.toString(), dat['Sample size']).includes("I/S") || finalvalue == null ? 0 : finalvalue)) / 2,
          color: 'transparent',
          dataLabels: { enabled: false },
        };
        series1.data.push(s1);
        series2.data.push(s2);
        series3.data.push(s3);

        if (i < data1.length - 1) {
          let s11 = {
            name: 'Others',
            y: 1000,
            y1: -1,
            color: 'transparent',
            dataLabels: { enabled: false },
            pointWidth: 2,
          };
          let s22 = {
            name: '',
            y: 1000,
            y1: -1,
            actualcolor: 'transparent',
            conversion: diff[i++],
            color: 'transparent',
            samplesize: dat['Sample size'],
            cov: dat['Change value vs PY'],
            significance: dat['Significance'],
            significance2: dat['Significance2'],
            tooltip: '',
            isPercentage: true,
            Sig_LowerLimt: this.Sig_LowerLimt,
            Sig_UpperLimt: this.Sig_UpperLimt,
            Significance_Value: dat['Significance_Value'],
            // dataLabels: { enabled: false },
            pointWidth: 2,
          };
          let s33 = {
            name: 'Others',
            y: 1000,
            y1: -1,
            color: 'transparent',
            dataLabels: { enabled: false },
            pointWidth: 2,
          };

          //console.log((maxdatapoint2 - Number(parseFloat(diff[i]).toFixed(1))) / 2,Number(parseFloat(diff[i]).toFixed(1)),(maxdatapoint2 - Number(parseFloat(diff[i]).toFixed(1))) / 2)
          series1.data.push(s11);
          series2.data.push(s22);
          series3.data.push(s33);
          xaxis.push('');
        }

      });
      seriesdata = [series1, series2, series3];
      this.seriesdata = seriesdata;
      this.xaxis = xaxis;
      ;
    }
  }

  plotLines: any = [];
  // plotChart(containerId: any, jsondata: any, chartproperties: any) {
  //   const maxLabelCharacters = this.popUp ? 30 : 20;
  //   localStorage.setItem('properties', JSON.stringify(chartproperties));
  //   let samplesizeconstant = this.samplesizeconstant;
  //   HC_accessibility(Highcharts);
  //   this.preparechartdata(
  //     jsondata,
  //     chartproperties.datalabelStyle == 'ls',
  //     chartproperties.gradientBarColor
  //   );
  //   for (let i = 0; i < this.seriesdata[1].data.length; i++) {
  //     const plotLine: Highcharts.XAxisPlotLinesOptions = {
  //       value: i,
  //       width: 1,
  //       dashStyle: 'Dash',
  //     };

  //     this.plotLines.push(plotLine);
  //   }
  //   this.chart = Highcharts.chart(containerId, {
  //     chart: {
  //       type: 'bar',
  //       backgroundColor: chartproperties.darkTheme ? '#333' : 'white',
  //       style:{
  //         fontFamily: this.uniquechartservice.textfont,
  //         }
  //     },
  //     title: {
  //       text: "",
  //       align: chartproperties.chartTitlePosition,
  //       verticalAlign: 'top',
  //       style: {
  //         color: chartproperties.darkTheme ? 'white' : 'black',
  //       },
  //     },
  //     xAxis: {
  //       categories: this.xaxis,
  //       min: 0,
  //       max: this.chartproperties.numberOfFunnelLevels - 1,
  //       scrollbar: {
  //         //enabled: this.xaxis.length>8?true:false,
  //         enabled: false,
  //         height: 6, // Adjust the height of the scrollbar as needed
  //         barBackgroundColor: '#0060FF',
  //         barBorderRadius: 5,
  //         barBorderWidth: 0,
  //         barBorderColor:  chartproperties.darkTheme ? '#333':'white',
  //         buttonBackgroundColor: chartproperties.darkTheme ? '#333':'white',
  //         buttonBorderWidth: 0,
  //         buttonArrowColor:chartproperties.darkTheme ? '#333':'white',
  //         buttonBorderRadius: 5,
  //         rifleColor: 'none',
  //         trackBackgroundColor:  chartproperties.darkTheme ? '#333':'white',
  //         trackBorderWidth: 0,
  //         trackBorderColor: 'black',
  //         trackBorderRadius: 5
  //       },
  //       labels: {
  //         useHTML: true,
  //         style: {
  //           //fontFamily: this.barService.textfont,
  //           // Add CSS styles for text overflow
  //           whiteSpace: 'nowrap',
  //           textOverflow: 'ellipsis',
  //           color: chartproperties.darkTheme ? 'white' : 'black',
  //           fontSize:"0.7rem"
  //         },
  //         formatter: function (this: Highcharts.AxisLabelsFormatterContextObject) {


  //           let labelContent = String(this.value);

  //           //// Limit the number of characters only if axis label orientation is vertical
  //           //if (properties.axisLabelOrientation === "vertical") {
  //           if (labelContent.length > maxLabelCharacters) {
  //             labelContent = labelContent.substring(0, maxLabelCharacters) + '...';
  //           }
  //           //}

  //           return `<div style="width:6.5rem;text-align:right"title="${String(this.value)}">${labelContent}</div>`;

  //         },



  //         overflow: 'justify', // Handle overflow with justification
  //         //rotation: this.barService.axisLabelOrientation(this.properties.axisLabelOrientation), // Rotate labels by -90 degrees (or any other desired angle)
  //       },


  //       plotLines: chartproperties.horizontalErrorBar ? this.plotLines : [{}],
  //       gridLineWidth: chartproperties.gridlines ? 1 : 0,
  //       alternateGridColor: chartproperties.plotBands
  //         ? !chartproperties.darkTheme
  //           ? '#eeebed'
  //           : '#7f7f7f'
  //         : '',
  //     },
  //     yAxis: {
  //       min: 0,
  //       gridLineWidth: 0,
  //       visible: false,
  //     },
  //     legend: {
  //       enabled: false,
  //       reversed: true,
  //     },
  //     tooltip: {
  //       enabled: true,
  //       borderWidth: 0,
  //       useHTML: true,
  //       shape: chartproperties.toolTipStyle == "style1" ? 'square' : 'callout',
  //       shadow: false,
  //       backgroundColor: 'rgba(0,0,0,0)',


  //       formatter: function (this: any):any {
  //         const pointWithMetric = this.point as {
  //           name?:any;
  //           parent?:any;
  //           actualcolor?:any,
  //           color?:any;
  //           y?: number;
  //           y1?:number;
  //           cov?: string;
  //           significance?: string;
  //           significance2?: string;
  //           samplesize?: number;
  //           tooltip?:any
  //         };
  //         if (this.color == 'transparent') {
  //           return false;
  //         }
  //         const backgroundcolor = chartproperties.darkTheme ? '#b3b3b3' : '#f5f5f5';
  //         const backgroundcolor2 = chartproperties.darkTheme ? '#dddddd' : 'white';
  //         if(pointWithMetric.tooltip==""){pointWithMetric.tooltip=pointWithMetric.y1==null?'NA':pointWithMetric.y}

  //         let isDefaultTooltip = chartproperties.toolTipStyle;
  //         if (isDefaultTooltip == "style1") {
  //           const dotColor = pointWithMetric.actualcolor;
  //           const commonContent =
  //             `<div style="border-left: 5px solid `+dotColor+`; border-bottom: 5px solid `+dotColor+`; z-index: 100; padding: 5px; border-radius: 5px; margin: 0px; background-color :${backgroundcolor2};">` +
  //             `<span style="display: block; text-align: center; color: `+dotColor+`; font-weight: bold; font-size: 12px;">Tooltip Title</span>` +
  //             `<span><strong>Series Name:</strong></span>Brands<br>` +
  //             `<span><strong>Category Name:</strong></span> ${pointWithMetric.name}<br>` +
  //             `<span><strong>Value:</strong></span> ${pointWithMetric.tooltip}`;
  //           return commonContent + '</div>';
  //         }
  //         else {
  //           const dotColor = pointWithMetric.actualcolor; // Get the series color

  //           const content =
  //             `<div style="background-color: ${backgroundcolor}; padding: 5px; align-items: center; border: 1px solid ${dotColor}; ">` +
  //             `<div style="width: 10px; height: 10px; background-color: ${dotColor}; border-radius: 50%; margin-right: 5px;"><div style="padding-left:10px;margin-top:0">${pointWithMetric.name}</div></div>`  +
  //             `<div style="display: block; margin-top: 5px;"><strong>Value:</strong> ${pointWithMetric.tooltip}</div>`;

  //           return content + '</div>';

  //         }



  //       },
  //    },
  //     plotOptions: {
  //       series: {
  //         animation: false,
  //         stacking: 'percent',
  //         borderWidth: chartproperties.border ? 2 : 0,
  //         borderColor: chartproperties.darkTheme ? 'white' : 'black',
  //         shadow: chartproperties.shadow
  //           ? {
  //               color: chartproperties.darkTheme?'white':'rgba(0, 0, 0, 0.5)',
  //               offsetX: 1,
  //               offsetY: 1,
  //               opacity: 0.5,
  //               width: 6,
  //             }
  //           : false,
  //         dataLabels: {
  //           crop: false,
  //           overflow: 'allow',
  //           enabled: chartproperties.showDataLabel,
  //           color:
  //             chartproperties.dataLabelColor == 'default'
  //               ? chartproperties.darkTheme
  //                 ? 'white'
  //                 : 'black'
  //               : chartproperties.dataLabelColor,
  //           align:
  //             chartproperties.dataLabelPosition == 'Center'
  //               ? 'center'
  //               : chartproperties.dataLabelPosition == 'Inside Base'
  //               ? 'left'
  //               : 'right',
  //           style: {
  //             fontSize: chartproperties.dataLabelSize,
  //             textOutline: 'none',
  //             fontWeight:"normal"
  //           },
  //           formatter: function (
  //             this: Highcharts.TooltipFormatterContextObject
  //           ): any {
  //             const pointWithMetric = this.point as {
  //               name?: any;
  //               color?: any;
  //               y?: number;
  //               y1?: number;
  //               cov?: string;
  //               significance?: string;
  //               significance2?: string;
  //               samplesize?: number;
  //               tooltip?: any;
  //             };
  //             let textcolor = chartproperties.darkTheme ? 'white' : 'black';
  //             if (chartproperties.datalabelStyle === 'default') {
  //               let text =
  //                 pointWithMetric.y1 != null
  //                   ? pointWithMetric.y +
  //                     (chartproperties.dataLabelFormat ? '%' : '')
  //                   : 'NA';
  //               pointWithMetric.tooltip = text;
  //               return (
  //                 '<span>' +
  //                 text +
  //                 '</span> ' +
  //                 '<span style="opacity: 0.5"></span>'
  //               );
  //             } else if (chartproperties.datalabelStyle === 'change') {
  //               let text =
  //                 pointWithMetric.y1 != null
  //                   ? pointWithMetric.y +
  //                     (chartproperties.dataLabelFormat ? '%' : '') +
  //                     ' ' +
  //                     `<span span style="font-size: 80%;color:` +
  //                     (chartproperties.darkTheme ? 'white' : 'black') +
  //                     `">(` +
  //                     (Number(pointWithMetric.cov) > 0 ? '+' : '') +
  //                     `${pointWithMetric.cov} )</span>`
  //                   : 'NA';
  //               pointWithMetric.tooltip = text;
  //               return (
  //                 '<span style:"color:' + textcolor + ';">' + text + '</span>'
  //               );
  //             } else if (
  //               chartproperties.datalabelStyle === 'significance + changeVs'
  //             ) {
  //               const upwardTriangle = '\u25B2';
  //               const downwardTriangle = '\u25BC';
  //               let sig = Number(pointWithMetric.significance);
  //               let s =
  //                 sig > 0 ? upwardTriangle : sig < 0 ? downwardTriangle : '';
  //               let sigcolor = sig > 0 ? 'green' : sig < 0 ? 'red' : '';
  //               let text =
  //                 pointWithMetric.y1 != null
  //                   ? pointWithMetric.y +
  //                     (chartproperties.dataLabelFormat ? '%' : '') +
  //                     ' ' +
  //                     `<span span style="font-size: 80%;color:` +
  //                     (chartproperties.darkTheme ? 'white' : 'black') +
  //                     `">(` +
  //                     (Number(pointWithMetric.cov) > 0 ? '+' : '') +
  //                     `${pointWithMetric.cov} )</span>` +
  //                     '<span style="color:' +
  //                     sigcolor +
  //                     ';">' +
  //                     s +
  //                     '</span>'
  //                   : 'NA';
  //               pointWithMetric.tooltip = text;
  //               return (
  //                 '<span style:"color:' + textcolor + ';">' + text + '</span>'
  //               );
  //             } else if (chartproperties.datalabelStyle === 'significance') {
  //               const upwardTriangle = '\u25B2';
  //               const downwardTriangle = '\u25BC';
  //               let sig = Number(pointWithMetric.significance);
  //               let s =
  //                 sig > 0 ? upwardTriangle : sig < 0 ? downwardTriangle : '';
  //               let sigcolor = sig > 0 ? 'green' : sig < 0 ? 'red' : '';

  //               let text =
  //                 pointWithMetric.y1 != null
  //                   ? pointWithMetric.y +
  //                     (chartproperties.dataLabelFormat ? '%' : '') +
  //                     '<span style="color:' +
  //                     sigcolor +
  //                     ';">' +
  //                     s +
  //                     '</span>'
  //                   : 'NA';
  //               pointWithMetric.tooltip = text;
  //               return (
  //                 '<span style:"color:' + textcolor + ';">' + text + '</span>'
  //               );
  //             } else if (chartproperties.datalabelStyle === 'ls') {
  //               let text =
  //                 Number(pointWithMetric.samplesize) > samplesizeconstant
  //                   ? pointWithMetric.y1 == null
  //                     ? 'NA'
  //                     : pointWithMetric.y +
  //                       (chartproperties.dataLabelFormat ? '%' : '')
  //                   : 'LS';
  //               pointWithMetric.tooltip = text;
  //               return (
  //                 '<span>' +
  //                 text +
  //                 '</span> ' +
  //                 '<span style="opacity: 0.5"></span>'
  //               );
  //             } else if (chartproperties.datalabelStyle == 'significance2') {
  //               const upwardTriangle = '\u25B2';
  //               const downwardTriangle = '\u25BC';
  //               let text =
  //                 pointWithMetric.y1 != null
  //                   ? this.y + (chartproperties.dataLabelFormat ? '%' : '')
  //                   : 'NA';
  //               let changeText = pointWithMetric.cov;
  //               let sig = Number(pointWithMetric.significance);
  //               let sig1 = Number(pointWithMetric.significance2);
  //               let sColor =
  //                 Number(sig) > 0 ? 'green' : Number(sig) < 0 ? 'red' : '';
  //               let s =
  //                 Number(sig) > 0
  //                   ? upwardTriangle
  //                   : Number(sig) < 0
  //                   ? downwardTriangle
  //                   : '';
  //               let changeColor =
  //                 sig1 < 0
  //                   ? 'red'
  //                   : sig1 > 0
  //                   ? 'green'
  //                   : chartproperties.darkTheme
  //                   ? 'white'
  //                   : 'black';
  //               if (Number(changeText) > 0) {
  //                 changeText = '+' + changeText;
  //               }
  //               pointWithMetric.tooltip = text;
  //               return (
  //                 '<span>' +
  //                 text +
  //                 (pointWithMetric.y1 != null && changeText
  //                   ? '&nbsp<span style="color:' +
  //                     ';"> ' +
  //                     '<span style="font-size: 80%; color:' +
  //                     changeColor +
  //                     ';">(' +
  //                     changeText +
  //                     ')</span> &nbsp' +
  //                     '<span style="color:' +
  //                     sColor +
  //                     ';">' +
  //                     s +
  //                     '</span>'
  //                   : '') +
  //                 '</span>'
  //               );
  //             }
  //             else{
  //               let text =
  //                 pointWithMetric.y1 != null
  //                   ? pointWithMetric.y +
  //                     (chartproperties.dataLabelFormat ? '%' : '')
  //                   : 'NA';
  //               pointWithMetric.tooltip = text;
  //               return (
  //                 '<span>' +
  //                 text +
  //                 '</span> ' +
  //                 '<span style="opacity: 0.5"></span>'
  //               );
  //             }
  //           },
  //         },
  //       },
  //     },
  //     series: this.seriesdata,
  //     credits: {
  //       enabled: false,
  //     },
  //     exporting: {
  //       enabled: false,
  //     },
  //   }as Highcharts.Options);
  // }

  plotChart(containerId: any, jsondata: any, chartproperties: any) {
    let ht=this.height;
    const getPaddingRightVal = function (grid: any) {
      let xdatalabelposition = 0;
      const screenHeight = window.innerHeight;

      if (grid === "49% 49%") { // Use `===` for comparison
        if (screenHeight <= 610) {
          xdatalabelposition = 5;
        } else if (screenHeight <= 800) {
          xdatalabelposition = 4.5;
        } else if (screenHeight <= 1200) {
          xdatalabelposition = 6;
        }
      } else {
        if (screenHeight <= 610) {
          xdatalabelposition = ht=="22em" ? 9.5 : 2.8;
        } else if (screenHeight <= 800) {
          xdatalabelposition = ht=="22em" ? 9.1 :2.8; //2.3
        } else if (screenHeight <= 1200) {
          xdatalabelposition = ht=="22em" ? 11.4 : 3.3;
        }
      }

      return xdatalabelposition;
    };
    const getPaddingRightValforSigChange = function (grid: any) {
      let xdatalabelposition = 0;
      const screenHeight = window.innerHeight;

      if (grid === "49% 49%") { // Use `===` for comparison
        if (screenHeight <= 610) {
          xdatalabelposition = 70;
        } else if (screenHeight <= 800) {
          xdatalabelposition = 80;
        } else if (screenHeight <= 1200) {
          xdatalabelposition = 100;
        }
      } else {
        if (screenHeight <= 610) {
          xdatalabelposition = ht=="22em" ? 140 : 50;
        } else if (screenHeight <= 800) {
          xdatalabelposition = ht=="22em" ? 161 : 55; //2.3
        } else if (screenHeight <= 1200) {
          xdatalabelposition = ht=="22em" ? 195 : 60;
        }
      }

      return xdatalabelposition;
    };
    if (this.isOutput) {
      let gridTempleteColumns = this.gridTempleteColumns;
      let isXaxis = this.showXaxisLabels;
      const configService = this._configService;
      let multiFunnelPopup = this.multiFunnelPopup;
      localStorage.setItem('properties', JSON.stringify(chartproperties));
      let samplesizeconstant = this.samplesizeconstant;
      const maxLabelCharacters = this.popUp ? 30 : 20;
      HC_accessibility(Highcharts);
      this.preparemainChartData(this.customData);
      this.preparechartdata(
        this.chartMainData,
        chartproperties?.datalabelStyle == 'ls',
        chartproperties?.gradientBarColor
      );
      for (let i = 0; i < this.seriesdata[1].data.length; i++) {
        const plotLine: Highcharts.XAxisPlotLinesOptions = {
          value: i,
          width: 1,
          dashStyle: 'Dash',
        };

        this.plotLines.push(plotLine);
      }
      const popup = this.popUpp;
      const popUp = this.popUp
      this.chartproperties = this.configuredProperties != undefined ? this.configuredProperties : this.chartproperties;
      chartproperties = this.chartproperties;
      const options: Highcharts.Options = {
        chart: {
          type: 'bar',
          //  height:,
          backgroundColor: chartproperties.darkTheme ? '#333' : 'white',
          // spacingRight: 70,  // Add padding to the right
          style: {
            fontFamily: this.uniquechartservice.textfont,
            // height:200,
            fontSize: '0.7rem'
          },
          events: {
            load: function () {
              const chart = this;
              window.addEventListener('resize', function () {
                chart.reflow();
              });
            }
          }
        },
        title: {
          text: "",
          align: chartproperties.chartTitlePosition,
          verticalAlign: 'top',
          style: {
            color: chartproperties.darkTheme ? 'white' : 'black',
          },
        },
        xAxis: {
          lineWidth: 0,
          categories: this.xaxis,
          min: 0,
          max: !this.multiFunnelPopup ? (this.xaxis.length > 8 ? (this.popUp ? 8 : 6) : this.xaxis.length - 1) : this.xaxis.length - 1,
          scrollbar: {
            enabled: !this.multiFunnelPopup ? (this.xaxis.length > 4 ? (this.xaxis.length > 8 ? true : false) : false) : false,
            height: 5, // Adjust the height of the scrollbar as needed
            barBackgroundColor: '#802AB7',
            barBorderRadius: 5,
            barBorderWidth: 0,
            barBorderColor: this.chartproperties.darkTheme ? this.barService.darkThemeBackgroundColor : this.barService.defaultThemeBackgroundColor,
            buttonBackgroundColor: this.chartproperties.darkTheme ? this.barService.darkThemeBackgroundColor : this.barService.defaultThemeBackgroundColor,
            buttonBorderWidth: 0,
            buttonArrowColor: this.chartproperties.darkTheme ? this.barService.darkThemeBackgroundColor : this.barService.defaultThemeBackgroundColor,
            buttonBorderRadius: 5,
            rifleColor: 'none',
            trackBackgroundColor: this.chartproperties.darkTheme ? this.barService.darkThemeBackgroundColor : this.barService.defaultThemeBackgroundColor,
            trackBorderWidth: 0,
            trackBorderColor: 'black',
            trackBorderRadius: 5
          },
          labels: {
            enabled: this.showXaxisLabels,
            useHTML: true,
            style: {
              //fontFamily: this.barService.textfont,
              // Add CSS styles for text overflow
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              color: chartproperties.darkTheme ? 'white' : 'black',
            },
            formatter: function (this: Highcharts.AxisLabelsFormatterContextObject) {


              let labelContent = String(this.value);

              //// Limit the number of characters only if axis label orientation is vertical
              //if (properties.axisLabelOrientation === "vertical") {
              if (labelContent.length > maxLabelCharacters) {
                labelContent = labelContent.substring(0, maxLabelCharacters) + '...';
              }
              //}

              return `<div style="width:6.5rem;text-align:right"title="${String(this.value)}">${labelContent}</div>`;

            },



            overflow: 'justify', // Handle overflow with justification
            //rotation: this.barService.axisLabelOrientation(this.properties.axisLabelOrientation), // Rotate labels by -90 degrees (or any other desired angle)
          },

          plotLines: chartproperties.horizontalErrorBar ? this.plotLines : [{}],
          gridLineWidth: chartproperties.gridlines ? 1 : 0,
          alternateGridColor: chartproperties.plotBands
            ? !chartproperties.darkTheme
              ? '#eeebed'
              : '#7f7f7f'
            : '',
        },
        yAxis: {
          min: 0,
          max: this.chartproperties.datalabelStyle == 'datalabel' || this._configService.isIndexSelected ? 120 : 140,
          //max:120,
          gridLineWidth: 0,
          visible: false,
        },
        legend: {
          enabled: false,
          reversed: true,
        },
        tooltip: {
          enabled: true,
          borderWidth: 0,
          useHTML: true,
          // shape: chartproperties.toolTipStyle == "style1" ? 'square' : 'callout',
          shadow: false,
          backgroundColor: 'rgba(0,0,0,0)',


          formatter: function (this: any): any {
            const pointWithMetric = this.point as {
              name?: any;
              parent?: any;
              actualcolor?: any,
              color?: any;
              y?: number;
              y1?: number;
              cov?: string;
              significance?: string;
              significance2?: string;
              samplesize?: number;
              tooltip?: any;

            };
            if (this.color == 'transparent') {
              return false;
            }
            const backgroundcolor = chartproperties.darkTheme ? '#b3b3b3' : '#f5f5f5';
            const backgroundcolor2 = chartproperties.darkTheme ? '#dddddd' : 'white';
            if (pointWithMetric.tooltip == "") { pointWithMetric.tooltip = pointWithMetric.y1 == null ? 'NA' : pointWithMetric.y }

            let isDefaultTooltip = chartproperties.toolTipStyle;
            if (isDefaultTooltip == "style1") {
              const dotColor = pointWithMetric.actualcolor;
              const commonContent =
                `<div style="border-left: 2px solid ${dotColor}; border-bottom: 2px solid ${dotColor};  width: fit-content;z-index: 100; padding: 2%; border-radius: 5px; margin: 0; background-color: ${backgroundcolor2};">` +
                //`<span style="display: block; text-align: center; color: ${dotColor}; font-weight: bold; font-size: 0.8rem;">Tooltip Title</span>` +
                // `<span><strong>Series Name:</strong></span> ${this.point.seriesName}<br>` +
                `${pointWithMetric.name}: ` +
                ` ${pointWithMetric.tooltip}`;
              return commonContent + '</div>';
            }
            else {
              const dotColor = pointWithMetric.actualcolor; // Get the series color

              const content =
                `<div style="background-color: ${backgroundcolor}; padding: 5px; align-items: center; border: 1px solid ${dotColor}; ">` +
                `<div style="width: 10px; height: 10px; background-color: ${dotColor}; border-radius: 50%; margin-right: 5px;"><div style="padding-left:10px;margin-top:0">${pointWithMetric.name}</div></div>` +
                `<div style="display: block; margin-top: 5px;"><strong>Value:</strong> ${pointWithMetric.tooltip}</div>`;

              return content + '</div>';

            }



          },
        },
        plotOptions: {
          column: {
            pointPadding: 0.1,
            groupPadding: 0.1,
          },
          series: {
            // pointPadding: 0.1, 
            // groupPadding: 0.1,
            animation: false,
            stacking: 'percent',
            borderWidth: chartproperties.border ? 2 : 0,
            borderColor: chartproperties.darkTheme ? 'white' : 'black',
            shadow: chartproperties.shadow
              ? {
                color: 'rgba(0, 0, 0, 0.5)',
                offsetX: 1,
                offsetY: 1,
                opacity: 0.5,
                width: 6,
              }
              : false,
            dataLabels: {
              // y:15,
              //x: this.chartproperties.datalabelStyle=='sigChange'?40:this.chartproperties.datalabelStyle == 'datalabel' || this._configService.isIndexSelected ? 40 : 60,
              // x: this.chartproperties.datalabelStyle == 'datalabel' || this._configService.isIndexSelected ? 40 : 65,
              x: this.chartproperties.datalabelStyle == 'datalabel' ?!this._configService.isRespondentLevel?45: 40 :this.chartproperties.datalabelStyle == 'index'?90: 65,
              y: 0,
              useHTML: true,
              crop: false,
              overflow: 'allow',
              inside: false,
              enabled: chartproperties.showDataLabel,
              color:
                chartproperties.dataLabelColor == 'default'
                  ? chartproperties.darkTheme
                    ? 'white'
                    : 'black'
                  : chartproperties.dataLabelColor,
              align:
                chartproperties.dataLabelPosition == 'Center'
                  ? 'center'
                  : chartproperties.dataLabelPosition == 'Inside Base'
                    ? 'left'
                    : 'right',
              style: {
                fontSize: '0.7em',
                textOutline: 'none',
                fontWeight: "normal"
              },
              formatter: function (
                this: Highcharts.TooltipFormatterContextObject
              ): any {
                ;
                const pointWithMetric = this.point as {
                  name?: any;
                  color?: any;
                  y?: number;
                  y1?: number;
                  cov?: string;
                  significance?: string;
                  significance2?: string;
                  samplesize?: number;
                  tooltip?: any;
                  options?: any;
                  isPercentage?: any;
                  conversion?: any;
                  Sig_LowerLimt?: any;
                  Sig_UpperLimt?: any;
                  Significance_Value?: any;
                  indexValue?: any;
                  actualIndexValue?: any;
                  isLastSeries?: any;
                };
                let textcolor = chartproperties.darkTheme ? 'white' : 'black';
                let paddingRightVal = pointWithMetric.name != "" ? 0 : 25;
                if (chartproperties.datalabelStyle === 'datalabel') {
                  let text =
                    pointWithMetric.y1 != null || NaN
                      ? pointWithMetric.y +
                      (chartproperties.dataLabelFormat ? '%' : '')
                      : 'NA';
                  text = pointWithMetric.name != "" ? (configService.CheckLSorIScondition(configService.userRole, text + (pointWithMetric.isPercentage && (!configService.CheckLSorIScondition(configService.userRole, text, Number(pointWithMetric.samplesize)).includes('I/S') || !configService.CheckLSorIScondition(configService.userRole, text, Number(pointWithMetric.samplesize)).includes('NA')) ? '%' : ''), Number(pointWithMetric.samplesize))) : (!isNaN(pointWithMetric.conversion) ? (parseFloat(pointWithMetric.conversion).toFixed(1)) : pointWithMetric.conversion) + (pointWithMetric.conversion.toString().includes('I/S') || pointWithMetric.conversion.toString().includes('NA') ? "" : "%");
                  let con = parseFloat(pointWithMetric.options.conversion).toFixed(1);
                  pointWithMetric.tooltip = text;

                  let numericValue = parseFloat(text.replace('%', ''));
                  paddingRightVal = pointWithMetric.name != "" ? 0 : (!multiFunnelPopup ? (popUp ? 6 : getPaddingRightVal(gridTempleteColumns.trim())) : !isXaxis ? 3.8 : 2.8);

                  if (con != "NaN" && pointWithMetric.name == "") {
                    return (
                      '<div >' +
                      '<div style="padding-right:' + paddingRightVal + 'rem;">' +
                      text +
                      '</div> '
                      // +'<br>'+'<br>'+'<br>'
                      // +'<div >'+con+'</div> '+'</div>'
                    );
                  }
                  else if (con == "NaN" && pointWithMetric.name == "") {
                    paddingRightVal += 0.35;
                    return (
                      '<div >' +
                      '<div style="padding-right:' + paddingRightVal + 'rem;">' +
                      text +
                      '</div> '
                      // +'<br>'+'<br>'+'<br>'
                      // +'<div >'+con+'</div> '+'</div>'
                    );
                  }
                  else if (text == "0%" && pointWithMetric.name != "") {
                    console.log("yes its 0")
                    const screenHeight = window.innerHeight;
                    if (screenHeight <= 610) { //150%
                      paddingRightVal += 1.5;
                    }
                    else if (screenHeight <= 800) {
                      paddingRightVal += 1.35;
                    }
                    else if (screenHeight <= 1200) {
                      paddingRightVal += 2;
                    }
                    // paddingRightVal += 1.35;
                    return (
                      '<div >' +
                      '<div style="padding-right:' + paddingRightVal + 'rem;">' +
                      text +
                      '</div> '
                      // +'<br>'+'<br>'+'<br>'
                      // +'<div >'+con+'</div> '+'</div>'
                    );
                  }
                  else {
                    return ('<div style="padding-right:' + (text == "NA" ? '0' : paddingRightVal) + 'px;">' +
                      text +
                      '</div> ');
                  }

                }
                else if (chartproperties.datalabelStyle === "index") {

                  let text =
                    pointWithMetric.y1 != null || NaN
                      ? pointWithMetric.y +
                      (chartproperties.dataLabelFormat ? '%' : '')
                      : 'NA';
                  text = pointWithMetric.name != "" ? (configService.CheckLSorIScondition(configService.userRole, text + (pointWithMetric.isPercentage && (!configService.CheckLSorIScondition(configService.userRole, text, Number(pointWithMetric.samplesize)).includes('I/S') || !configService.CheckLSorIScondition(configService.userRole, text, Number(pointWithMetric.samplesize)).includes('NA')) ? '%' : ''), Number(pointWithMetric.samplesize))) : (!isNaN(pointWithMetric.conversion) ? (parseFloat(pointWithMetric.conversion).toFixed(1)) : pointWithMetric.conversion) + (pointWithMetric.conversion.toString().includes('I/S') || pointWithMetric.conversion.toString().includes('NA') ? "" : "%");
                  // let con = parseFloat(pointWithMetric.options.conversion).toFixed(1);
                  // pointWithMetric.tooltip = text;

                  // let numericValue = parseFloat(text.replace('%', ''));
                  // let text = this.series.userOptions.roundedValue[this.point.x - 1] != null ? this.y : serviceBar.nullValueText;
                  // if (text == "0") {
                  //   text = "NA";
                  // }
                  // let color = configService.CheckIndexColoring(text);
                  // //// ;
                  // this.series.userOptions.tooltip[this.point.x - 1] = text;
                  // return (
                  //   '<span style="color:' + color + ';">' + text + '</span>'
                  // );
                  paddingRightVal = pointWithMetric.name != "" ? 0 : popup ? 90 : 50;
                  if(pointWithMetric.y1==0){
                    paddingRightVal+=35
                  }



                  // let text2 = pointWithMetric.y1==0?'NA':pointWithMetric.y1 == -1 ? -1 :
                  //   pointWithMetric.y1 != null
                  //     ? pointWithMetric.indexValue.toFixed(1)
                  //     : 'NA';
                  let text2 = pointWithMetric.actualIndexValue == null ? 'NA' : pointWithMetric.y1 == -1 ? -1 :
                    pointWithMetric.y1 != null
                      ? pointWithMetric.indexValue.toFixed(1)
                      : 'NA';
                  if (text2 == "-1" || text2 == -1) {
                    text2 = "NA";
                  }
                  //text2 = pointWithMetric.name != "" ? (configService.CheckLSorIScondition(configService.userRole, text2 + (pointWithMetric.isPercentage && (!configService.CheckLSorIScondition(configService.userRole, String(text2), Number(pointWithMetric.samplesize)).includes('I/S') || !configService.CheckLSorIScondition(configService.userRole, String(text2), Number(pointWithMetric.samplesize)).includes('NA')) ? '%' : ''), Number(pointWithMetric.samplesize))) : (!isNaN(pointWithMetric.conversion) ? (parseFloat(pointWithMetric.conversion).toFixed(1)) : pointWithMetric.conversion) + (pointWithMetric.conversion.toString().includes('I/S') || pointWithMetric.conversion.toString().includes('NA') ? "" : "%");

                  let color = configService.CheckIndexColoring(String(text2));
                  pointWithMetric.tooltip = text + "(" + text2 + ")";

                  let con = parseFloat(pointWithMetric.options.conversion).toFixed(1);
                  pointWithMetric.tooltip = text + "(" + text2 + ")";
                  // if(pointWithMetric.tooltip.length>10){
                  //   paddingRightVal=-80
                  // }
                  if (con != "NaN" || pointWithMetric.options.isLastSeries != false) {
                    return (
                      '<div>' +
                      '<div style="color: ' + (pointWithMetric.name === "" ? 'white' : 'black') + '; padding-right: ' + paddingRightVal + 'px;">' +
                      text + ' (<span style="color:' + (pointWithMetric.name === "" ? 'white' : color) + ';">' + text2 + '</span>)' +
                      '</div>' +
                      '</div>'
                    );


                  }
                  else {
                    return (
                      '<div style="color: ' + (pointWithMetric.name == "" ? 'white' : color) + '; padding-right: ' + paddingRightVal + 'px;">' +
                      text + ' (' + text2 + ')' +
                      '</div>'
                    );

                  }
                  // return (
                  //   '<span style:"color:' + color + ';">' + text + '</span>'
                  // );

                }
                else if (chartproperties.datalabelStyle === 'sigChange') {
                  let textCheck = pointWithMetric.name != "" ? (configService.CheckLSorIScondition(configService.userRole, pointWithMetric.y1 + (pointWithMetric.isPercentage && (!configService.CheckLSorIScondition(configService.userRole, String(pointWithMetric.y1), Number(pointWithMetric.samplesize)).includes('I/S') || !configService.CheckLSorIScondition(configService.userRole, String(pointWithMetric.y1), Number(pointWithMetric.samplesize)).includes('NA')) ? '%' : ''), Number(pointWithMetric.samplesize))) : (!isNaN(pointWithMetric.conversion) ? (parseFloat(pointWithMetric.conversion).toFixed(1)) : pointWithMetric.conversion) + (pointWithMetric.conversion.toString().includes('I/S') || pointWithMetric.conversion.toString().includes('NA') ? "" : "%");

                  //paddingRightVal = pointWithMetric.name != "" ? 0 : 30;
                  if (pointWithMetric.name == '') {
                    let text = textCheck;
                    // pointWithMetric.y1 != null
                    //   ? pointWithMetric.y +
                    //   (pointWithMetric.isPercentage ? '%' : '')
                    //   : 'NA';
                    pointWithMetric.tooltip = text;
                    let popupPadding = 100;
                    if (popUp) {
                      const screenHeight = window.innerHeight;
                      if (screenHeight <= 610) { //150%
                        popupPadding = 100
                      }
                      else if (screenHeight <= 800) {
                        popupPadding = 110
                      }
                      else if (screenHeight <= 1200) {
                        popupPadding = 120
                      }
                    }

                    let numericValue = parseFloat(text.replace('%', ''));
                    paddingRightVal = pointWithMetric.name != "" ? 0 : !multiFunnelPopup ? (popUp ? popupPadding : getPaddingRightValforSigChange(gridTempleteColumns.trim())) : !isXaxis ? 65 : 56;
                    if (text == "NA") {
                      paddingRightVal += 10
                    }
                    return (
                      '<span style="padding-right:' + (paddingRightVal + 20) + 'px; color:' + textcolor + '; ">' + text + '</span>'
                    );
                  }
                  else {
                    let changeVal = pointWithMetric.isPercentage ? (Number(pointWithMetric.cov) * 100) : (Number(pointWithMetric.cov));
                    let sigClass = pointWithMetric.Significance_Value < pointWithMetric.Sig_LowerLimt ? 'red' : (pointWithMetric.Significance_Value > pointWithMetric.Sig_UpperLimt ? 'green' : 'black');
                    if (pointWithMetric.cov == null || pointWithMetric.cov == 'NA') {
                      let text = textCheck +
                        // pointWithMetric.y1 != null
                        //   ? pointWithMetric.y +
                        //   (pointWithMetric.isPercentage ? '%' : '') +
                        '<span style="color:' +
                        sigClass +
                        ';font-size:80%;"> (NA)</span>';

                      pointWithMetric.tooltip = text;
                      if (pointWithMetric.y1 == 0) {
                        const screenHeight = window.innerHeight;
                        if (screenHeight <= 610) { //150%
                          if (popUp) {
                            paddingRightVal = 3.3
                          }
                          else {
                            paddingRightVal = 2.5
                          }
                        }
                        else if (screenHeight <= 800) {
                          paddingRightVal = 1.8
                        }
                        else if (screenHeight <= 1200) {
                          if (popUp) {
                            paddingRightVal = 2.4
                          }
                          else {
                            paddingRightVal = 1.3
                          }
                        }
                      }
                      else {
                        paddingRightVal = 0
                      }
                      return (
                        '<div style="color:' + textcolor + ';padding-right:' + paddingRightVal + 'rem;">' + text + '</div>'
                      );
                    }
                    else {
                      let text = textCheck + ' ' +
                        // pointWithMetric.y1 != null
                        //   ? pointWithMetric.y +
                        //   (pointWithMetric.isPercentage ? '%' : '') +
                        (textCheck != 'I/S' ? ('<span style="color:' +
                          sigClass +
                          '; font-size:80%">(' +
                          ((changeVal.toFixed(1)) + (pointWithMetric.isPercentage ? '%' : '')) +
                          ')</span>') : '');

                      pointWithMetric.tooltip = text;
                      if (pointWithMetric.y1 == 0) {
                        paddingRightVal = 1
                        console.log("else block")
                      }
                      else {
                        paddingRightVal = 0
                      }
                      return (
                        '<div style="color:' + textcolor + ';padding-right:' + (paddingRightVal) + 'rem;">' + text + '</div>'
                      );
                    }
                  }



                  // return "hi"
                }
                else if (chartproperties.datalabelStyle === 'change') {
                  let text =
                    pointWithMetric.y1 != null
                      ? pointWithMetric.y +
                      (chartproperties.dataLabelFormat ? '%' : '') +
                      ' ' +
                      `<span span style="font-size: 80%;color:` +
                      (chartproperties.darkTheme ? 'white' : 'black') +
                      `">(` + `${pointWithMetric.cov} )</span>`
                      : 'NA';
                  pointWithMetric.tooltip = text;
                  return (
                    '<span style:"color:' + textcolor + ';">' + text + '</span>'
                  );
                } else if (
                  chartproperties.datalabelStyle === 'significance + changeVs'
                ) {
                  const upwardTriangle = '\u25B2';
                  const downwardTriangle = '\u25BC';
                  let sig = Number(pointWithMetric.significance);
                  let s =
                    sig > 0 ? upwardTriangle : sig < 0 ? downwardTriangle : '';
                  let sigcolor = sig > 0 ? 'green' : sig < 0 ? 'red' : '';
                  let text =
                    pointWithMetric.y1 != null
                      ? pointWithMetric.y +
                      (chartproperties.dataLabelFormat ? '%' : '') +
                      ' ' +
                      `<span span style="font-size: 80%;color:` +
                      (chartproperties.darkTheme ? 'white' : 'black') +
                      `">(` +
                      (Number(pointWithMetric.cov) > 0 ? '+' : '') +
                      `${pointWithMetric.cov} )</span>` +
                      '<span style="color:' +
                      sigcolor +
                      ';">' +
                      s +
                      '</span>'
                      : 'NA';
                  pointWithMetric.tooltip = text;
                  return (
                    '<span style:"color:' + textcolor + ';">' + text + '</span>'
                  );
                } else if (chartproperties.datalabelStyle === 'significance') {
                  const upwardTriangle = '\u25B2';
                  const downwardTriangle = '\u25BC';
                  let sig = Number(pointWithMetric.significance);
                  let s =
                    sig > 0 ? upwardTriangle : sig < 0 ? downwardTriangle : '';
                  let sigcolor = sig > 0 ? 'green' : sig < 0 ? 'red' : '';

                  let text =
                    pointWithMetric.y1 != null
                      ? pointWithMetric.y +
                      (chartproperties.dataLabelFormat ? '%' : '') +
                      '<span style="color:' +
                      sigcolor +
                      ';">' +
                      s +
                      '</span>'
                      : 'NA';
                  pointWithMetric.tooltip = text;
                  return (
                    '<span style:"color:' + textcolor + ';">' + text + '</span>'
                  );
                } else if (chartproperties.datalabelStyle === 'ls') {
                  let text =
                    Number(pointWithMetric.samplesize) > samplesizeconstant
                      ? pointWithMetric.y1 == null
                        ? 'NA'
                        : pointWithMetric.y +
                        (chartproperties.dataLabelFormat ? '%' : '')
                      : 'LS';
                  pointWithMetric.tooltip = text;
                  return (
                    '<span>' +
                    pointWithMetric.name +
                    '</span> <span>' +
                    text +
                    '</span> ' +
                    '<span style="opacity: 0.5"></span>'
                  );
                } else if (chartproperties.datalabelStyle == 'significance2') {
                  const upwardTriangle = '\u25B2';
                  const downwardTriangle = '\u25BC';
                  let text =
                    pointWithMetric.y1 != null
                      ? this.y + (chartproperties.dataLabelFormat ? '%' : '')
                      : 'NA';
                  let changeText = pointWithMetric.cov;
                  let sig = Number(pointWithMetric.significance);
                  let sig1 = Number(pointWithMetric.significance2);
                  let sColor =
                    Number(sig) > 0 ? 'green' : Number(sig) < 0 ? 'red' : '';
                  let s =
                    Number(sig) > 0
                      ? upwardTriangle
                      : Number(sig) < 0
                        ? downwardTriangle
                        : '';
                  let changeColor =
                    sig1 < 0
                      ? 'red'
                      : sig1 > 0
                        ? 'green'
                        : chartproperties.darkTheme
                          ? 'white'
                          : 'black';
                  if (Number(changeText) > 0) {
                    changeText = '+' + changeText;
                  }
                  pointWithMetric.tooltip = text;
                  return (
                    '<span>' +
                    text +
                    (pointWithMetric.y1 != null && changeText
                      ? '&nbsp<span style="color:' +
                      ';"> ' +
                      '<span style="font-size: 80%; color:' +
                      changeColor +
                      ';">(' +
                      changeText +
                      ')</span> &nbsp' +
                      '<span style="color:' +
                      sColor +
                      ';">' +
                      s +
                      '</span>'
                      : '') +
                    '</span>'
                  );
                }
              },
            },
          },
        },
        series: this.seriesdata,

        credits: {
          enabled: false,
        },
        exporting: {
          enabled: false,
        },
      }
      Highcharts.chart('chart-container' + this.id, options);
    }
    else {
      const maxLabelCharacters = this.popUp ? 30 : 20;
      localStorage.setItem('properties', JSON.stringify(chartproperties));
      let samplesizeconstant = this.samplesizeconstant;
      HC_accessibility(Highcharts);
      this.preparechartdata(
        jsondata,
        chartproperties.datalabelStyle == 'ls',
        chartproperties.gradientBarColor
      );
      for (let i = 0; i < this.seriesdata[1].data.length; i++) {
        const plotLine: Highcharts.XAxisPlotLinesOptions = {
          value: i,
          width: 1,
          dashStyle: 'Dash',
        };

        this.plotLines.push(plotLine);
      }
      const options: Highcharts.Options = {
        chart: {
          type: 'bar',
          //  height:,
          backgroundColor: chartproperties.darkTheme ? '#333' : 'white',
          // spacingRight: 70,  // Add padding to the right
          style: {
            fontFamily: this.uniquechartservice.textfont,
            // height:200,
            fontSize: '0.7rem'
          },
          events: {
            load: function () {
              const chart = this;
              window.addEventListener('resize', function () {
                chart.reflow();
              });
            }
          }
        },
        title: {
          text: "",
          align: chartproperties.chartTitlePosition,
          verticalAlign: 'top',
          style: {
            color: chartproperties.darkTheme ? 'white' : 'black',
          },
        },
        xAxis: {
          lineWidth: 0,
          categories: this.xaxis,
          min: 0,
          max: this.chartproperties.numberOfFunnelLevels+this.chartproperties.numberOfFunnelLevels - 2,
          scrollbar: {
            enabled: false,
            height: 6, // Adjust the height of the scrollbar as needed
            barBackgroundColor: '#0060FF',
            barBorderRadius: 5,
            barBorderWidth: 0,
            barBorderColor: chartproperties.darkTheme ? '#333' : 'white',
            buttonBackgroundColor: chartproperties.darkTheme ? '#333' : 'white',
            buttonBorderWidth: 0,
            buttonArrowColor: chartproperties.darkTheme ? '#333' : 'white',
            buttonBorderRadius: 5,
            rifleColor: 'none',
            trackBackgroundColor: chartproperties.darkTheme ? '#333' : 'white',
            trackBorderWidth: 0,
            trackBorderColor: 'black',
            trackBorderRadius: 5
          },
          labels: {
            enabled: this.showXaxisLabels,
            useHTML: true,
            style: {
              //fontFamily: this.barService.textfont,
              // Add CSS styles for text overflow
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              color: chartproperties.darkTheme ? 'white' : 'black',
              fontSize: "0.7rem"
            },
            formatter: function (this: Highcharts.AxisLabelsFormatterContextObject) {


              let labelContent = String(this.value);

              //// Limit the number of characters only if axis label orientation is vertical
              //if (properties.axisLabelOrientation === "vertical") {
              if (labelContent.length > maxLabelCharacters) {
                labelContent = labelContent.substring(0, maxLabelCharacters) + '...';
              }
              //}

              return `<div style="width:6.5rem;text-align:right"title="${String(this.value)}">${labelContent}</div>`;

            },



            overflow: 'justify', // Handle overflow with justification
            //rotation: this.barService.axisLabelOrientation(this.properties.axisLabelOrientation), // Rotate labels by -90 degrees (or any other desired angle)
          },

          plotLines: chartproperties.horizontalErrorBar ? this.plotLines : [{}],
          gridLineWidth: chartproperties.gridlines ? 1 : 0,
          alternateGridColor: chartproperties.plotBands
            ? !chartproperties.darkTheme
              ? '#eeebed'
              : '#7f7f7f'
            : '',
        },
        yAxis: {
          min: 0,
          gridLineWidth: 0,
          visible: false,
        },
        legend: {
          enabled: false,
          reversed: true,
        },
        tooltip: {
          enabled: true,
          borderWidth: 0,
          useHTML: true,
          //shape: chartproperties.toolTipStyle == "style1" ? 'square' : 'callout',
          shadow: false,
          backgroundColor: 'rgba(0,0,0,0)',


          formatter: function (this: any): any {
            const pointWithMetric = this.point as {
              name?: any;
              parent?: any;
              actualcolor?: any,
              color?: any;
              y?: number;
              y1?: number;
              cov?: string;
              significance?: string;
              significance2?: string;
              samplesize?: number;
              tooltip?: any;

            };
            if (this.color == 'transparent') {
              return false;
            }
            const backgroundcolor = chartproperties.darkTheme ? '#b3b3b3' : '#f5f5f5';
            const backgroundcolor2 = chartproperties.darkTheme ? '#dddddd' : 'white';
            if (pointWithMetric.tooltip == "") { pointWithMetric.tooltip = pointWithMetric.y1 == null ? 'NA' : pointWithMetric.y }

            let isDefaultTooltip = chartproperties.toolTipStyle;
            if (isDefaultTooltip == "style1") {
              const dotColor = pointWithMetric.color;
              const commonContent =
                `<div style="border-left: 2px solid ${dotColor}; border-bottom: 2px solid ${dotColor};  width: fit-content;z-index: 100; padding: 2%; border-radius: 5px; margin: 0;font-size: 1em; background-color: ${backgroundcolor2};">` +
                //`<span style="display: block; text-align: center; color: ${dotColor}; font-weight: bold; font-size: 0.8rem;">Tooltip Title</span>` +
                // `<span><strong>Series Name:</strong></span> ${this.point.seriesName}<br>` +
                `${pointWithMetric.name}: ` +
                ` ${pointWithMetric.tooltip}`;
              return commonContent + '</div>';
            }
            else {
              const dotColor = pointWithMetric.actualcolor; // Get the series color

              const content =
                `<div style="background-color: ${backgroundcolor}; padding: 5px; align-items: center; border: 1px solid ${dotColor}; ">` +
                `<div style="width: 10px; height: 10px; background-color: ${dotColor}; border-radius: 50%; margin-right: 5px;"><div style="padding-left:10px;margin-top:0">${pointWithMetric.name}</div></div>` +
                `<div style="display: block; margin-top: 5px;"><strong>Value:</strong> ${pointWithMetric.tooltip}</div>`;

              return content + '</div>';

            }



          },
        },
        plotOptions: {
          column: {
            pointPadding: 0.1,
            groupPadding: 0.1,
          },
          series: {
            // pointPadding: 0.1, 
            // groupPadding: 0.1,
            animation: false,
            stacking: 'percent',
            borderWidth: chartproperties.border ? 2 : 0,
            borderColor: chartproperties.darkTheme ? 'white' : 'black',
            shadow: chartproperties.shadow
              ? {
                color: 'rgba(0, 0, 0, 0.5)',
                offsetX: 1,
                offsetY: 1,
                opacity: 0.5,
                width: 6,
              }
              : false,
            dataLabels: {
              // y:15,
              //x: this.chartproperties.datalabelStyle=='sigChange'?40:this.chartproperties.datalabelStyle == 'datalabel' || this._configService.isIndexSelected ? 40 : 60,
              // x: this.chartproperties.datalabelStyle == 'datalabel' || this._configService.isIndexSelected ? 40 : 65,
              x: this.chartproperties.datalabelStyle == 'datalabel' ? 40 :this.chartproperties.datalabelStyle == 'index'?90: 65,
              y: 0,
              useHTML: true,
              crop: false,
              overflow: 'allow',
              inside: false,
              enabled: chartproperties.showDataLabel,
              color:
                chartproperties.dataLabelColor == 'default'
                  ? chartproperties.darkTheme
                    ? 'white'
                    : 'black'
                  : chartproperties.dataLabelColor,
              align:
                chartproperties.dataLabelPosition == 'Center'
                  ? 'center'
                  : chartproperties.dataLabelPosition == 'Inside Base'
                    ? 'left'
                    : 'right',
              style: {
                fontSize: '0.7em',
                textOutline: 'none',
                fontWeight: "normal"
              },
              formatter: function (
                this: Highcharts.TooltipFormatterContextObject
              ): any {
                ;
                const pointWithMetric = this.point as {
                  name?: any;
                  color?: any;
                  y?: number;
                  y1?: number;
                  cov?: string;
                  significance?: string;
                  significance2?: string;
                  samplesize?: number;
                  tooltip?: any;
                  options?: any;
                  isPercentage?: any;
                  conversion?: any;
                  Sig_LowerLimt?: any;
                  Sig_UpperLimt?: any;
                  Significance_Value?: any;
                  indexValue?: any;
                  actualIndexValue?: any;
                  isLastSeries?: any;
                };
                let textcolor = chartproperties.darkTheme ? 'white' : 'black';
                let paddingRightVal = pointWithMetric.name != "" ? 0 : 25;
                if (chartproperties.datalabelStyle === 'datalabel') {
                  let text =
                    pointWithMetric.y1 != null || NaN
                      ? pointWithMetric.y +
                      (chartproperties.dataLabelFormat ? '%' : '')
                      : 'NA';
                      text = pointWithMetric.name != "" 
                      ? (text + (pointWithMetric.isPercentage ? '%' : '')) 
                      : (!isNaN(pointWithMetric.conversion) 
                          ? parseFloat(pointWithMetric.conversion).toFixed(1) 
                          : pointWithMetric.conversion) 
                      + (pointWithMetric.conversion.toString().includes('I/S') || pointWithMetric.conversion.toString().includes('NA') ? "" : "%");
                  let con = parseFloat(pointWithMetric.options.conversion).toFixed(1);
                  pointWithMetric.tooltip = text;

                  let numericValue = parseFloat(text.replace('%', ''));
                  paddingRightVal = pointWithMetric.name != "" ? 0 :  3.8 ;

                  if (con != "NaN" && pointWithMetric.name == "") {
                    return (
                      '<div >' +
                      '<div style="padding-right:' + paddingRightVal + 'rem;left: -103px;position: relative;">' +
                      text +
                      '</div> '
                      // +'<br>'+'<br>'+'<br>'
                      // +'<div >'+con+'</div> '+'</div>'
                    );
                  }
                  else if (con == "NaN" && pointWithMetric.name == "") {
                    paddingRightVal += 0.35;
                    return (
                      '<div >' +
                      '<div style="padding-right:' + paddingRightVal + 'rem;">' +
                      text +
                      '</div> '
                      // +'<br>'+'<br>'+'<br>'
                      // +'<div >'+con+'</div> '+'</div>'
                    );
                  }
                  else if (text == "0%" && pointWithMetric.name != "") {
                    console.log("yes its 0")
                    const screenHeight = window.innerHeight;
                    if (screenHeight <= 610) { //150%
                      paddingRightVal += 1.5;
                    }
                    else if (screenHeight <= 800) {
                      paddingRightVal += 1.35;
                    }
                    else if (screenHeight <= 1200) {
                      paddingRightVal += 2;
                    }
                    // paddingRightVal += 1.35;
                    return (
                      '<div >' +
                      '<div style="padding-right:' + paddingRightVal + 'rem;">' +
                      text +
                      '</div> '
                      // +'<br>'+'<br>'+'<br>'
                      // +'<div >'+con+'</div> '+'</div>'
                    );
                  }
                  else {
                    console.log('<div style="padding-right:' + (text == "NA" ? 0 : paddingRightVal) + 'px;">' +
                      text +
                      '</div> ')
                    return ('<div style="padding-right:' + (text == "NA" ? '0' : paddingRightVal) + 'px;">' +
                      text +
                      '</div> ');
                  }

                }
                else if (chartproperties.datalabelStyle === "index") {

                  let text =
                    pointWithMetric.y1 != null || NaN
                      ? pointWithMetric.y +
                      (chartproperties.dataLabelFormat ? '%' : '')
                      : 'NA';
                      text = pointWithMetric.name != "" 
                      ? (text + (pointWithMetric.isPercentage ? '%' : '')) 
                      : (!isNaN(pointWithMetric.conversion) 
                          ? parseFloat(pointWithMetric.conversion).toFixed(1) 
                          : pointWithMetric.conversion) 
                      + (pointWithMetric.conversion.toString().includes('I/S') || pointWithMetric.conversion.toString().includes('NA') ? "" : "%");
                  // let con = parseFloat(pointWithMetric.options.conversion).toFixed(1);
                  // pointWithMetric.tooltip = text;

                  // let numericValue = parseFloat(text.replace('%', ''));
                  // let text = this.series.userOptions.roundedValue[this.point.x - 1] != null ? this.y : serviceBar.nullValueText;
                  // if (text == "0") {
                  //   text = "NA";
                  // }
                  // let color = configService.CheckIndexColoring(text);
                  // //// ;
                  // this.series.userOptions.tooltip[this.point.x - 1] = text;
                  // return (
                  //   '<span style="color:' + color + ';">' + text + '</span>'
                  // );
                  paddingRightVal = pointWithMetric.name != "" ? 0 :  90 ;
                  if(pointWithMetric.y1==0){
                    paddingRightVal+=35
                  }



                  // let text2 = pointWithMetric.y1==0?'NA':pointWithMetric.y1 == -1 ? -1 :
                  //   pointWithMetric.y1 != null
                  //     ? pointWithMetric.indexValue.toFixed(1)
                  //     : 'NA';
                  let text2 = pointWithMetric.actualIndexValue == null ? 'NA' : pointWithMetric.y1 == -1 ? -1 :
                    pointWithMetric.y1 != null
                      ? pointWithMetric.indexValue.toFixed(1)
                      : 'NA';
                  if (text2 == "-1" || text2 == -1) {
                    text2 = "NA";
                  }
                  //text2 = pointWithMetric.name != "" ? (configService.CheckLSorIScondition(configService.userRole, text2 + (pointWithMetric.isPercentage && (!configService.CheckLSorIScondition(configService.userRole, String(text2), Number(pointWithMetric.samplesize)).includes('I/S') || !configService.CheckLSorIScondition(configService.userRole, String(text2), Number(pointWithMetric.samplesize)).includes('NA')) ? '%' : ''), Number(pointWithMetric.samplesize))) : (!isNaN(pointWithMetric.conversion) ? (parseFloat(pointWithMetric.conversion).toFixed(1)) : pointWithMetric.conversion) + (pointWithMetric.conversion.toString().includes('I/S') || pointWithMetric.conversion.toString().includes('NA') ? "" : "%");

                  let color = chartproperties.darkTheme ? 'white' : 'black';
                  pointWithMetric.tooltip = text + "(" + text2 + ")";

                  let con = parseFloat(pointWithMetric.options.conversion).toFixed(1);
                  pointWithMetric.tooltip = text + "(" + text2 + ")";
                  // if(pointWithMetric.tooltip.length>10){
                  //   paddingRightVal=-80
                  // }
                  if (con != "NaN" || pointWithMetric.options.isLastSeries != false) {
                    return (
                      '<div>' +
                      '<div style="color: ' + (pointWithMetric.name === "" ? 'white' : 'black') + '; padding-right: ' + paddingRightVal + 'px;">' +
                      text + ' (<span style="color:' + (pointWithMetric.name === "" ? 'white' : color) + ';">' + text2 + '</span>)' +
                      '</div>' +
                      '</div>'
                    );


                  }
                  else {
                    return (
                      '<div style="color: ' + (pointWithMetric.name == "" ? 'white' : color) + '; padding-right: ' + paddingRightVal + 'px;">' +
                      text + ' (' + text2 + ')' +
                      '</div>'
                    );

                  }
                  // return (
                  //   '<span style:"color:' + color + ';">' + text + '</span>'
                  // );

                }
                else if (chartproperties.datalabelStyle === 'sigChange') {
                  let textCheck = pointWithMetric.name != "" 
    ? (pointWithMetric.y1 + (pointWithMetric.isPercentage ? '%' : '')) 
    : (!isNaN(pointWithMetric.conversion) 
        ? parseFloat(pointWithMetric.conversion).toFixed(1) 
        : pointWithMetric.conversion) 
    + (pointWithMetric.conversion.toString().includes('I/S') || pointWithMetric.conversion.toString().includes('NA') ? "" : "%");

                  //paddingRightVal = pointWithMetric.name != "" ? 0 : 30;
                  if (pointWithMetric.name == '') {
                    let text = textCheck;
                    // pointWithMetric.y1 != null
                    //   ? pointWithMetric.y +
                    //   (pointWithMetric.isPercentage ? '%' : '')
                    //   : 'NA';
                    pointWithMetric.tooltip = text;
                    let popupPadding = 100;
                   
                    let numericValue = parseFloat(text.replace('%', ''));
                    paddingRightVal = pointWithMetric.name != "" ? 0 :  65 ;
                    if (text == "NA") {
                      paddingRightVal += 10
                    }
                    return (
                      '<span style="padding-right:' + (paddingRightVal + 20) + 'px; color:' + textcolor + '; ">' + text + '</span>'
                    );
                  }
                  else {
                    let changeVal = pointWithMetric.isPercentage ? (Number(pointWithMetric.cov) * 100) : (Number(pointWithMetric.cov));
                    let sigClass = pointWithMetric.Significance_Value < pointWithMetric.Sig_LowerLimt ? 'red' : (pointWithMetric.Significance_Value > pointWithMetric.Sig_UpperLimt ? 'green' : 'black');
                    if (pointWithMetric.cov == null || pointWithMetric.cov == 'NA') {
                      let text = textCheck +
                        // pointWithMetric.y1 != null
                        //   ? pointWithMetric.y +
                        //   (pointWithMetric.isPercentage ? '%' : '') +
                        '<span style="color:' +
                        sigClass +
                        ';font-size:80%;"> (NA)</span>';

                      pointWithMetric.tooltip = text;
                      if (pointWithMetric.y1 == 0) {
                        const screenHeight = window.innerHeight;
                        if (screenHeight <= 610) { //150%
                          
                         
                            paddingRightVal = 2.5
                          
                        }
                        else if (screenHeight <= 800) {
                          paddingRightVal = 1.8
                        }
                        else if (screenHeight <= 1200) {
                          
                            paddingRightVal = 1.3
                          
                        }
                      }
                      else {
                        paddingRightVal = 0
                      }
                      return (
                        '<div style="color:' + textcolor + ';padding-right:' + paddingRightVal + 'rem;">' + text + '</div>'
                      );
                    }
                    else {
                      let text = textCheck + ' ' +
                        // pointWithMetric.y1 != null
                        //   ? pointWithMetric.y +
                        //   (pointWithMetric.isPercentage ? '%' : '') +
                        (textCheck != 'I/S' ? ('<span style="color:' +
                          sigClass +
                          '; font-size:80%">(' +
                          ((changeVal.toFixed(1)) + (pointWithMetric.isPercentage ? '%' : '')) +
                          ')</span>') : '');

                      pointWithMetric.tooltip = text;
                      if (pointWithMetric.y1 == 0) {
                        paddingRightVal = 1
                        console.log("else block")
                      }
                      else {
                        paddingRightVal = 0
                      }
                      return (
                        '<div style="color:' + textcolor + ';padding-right:' + (paddingRightVal) + 'rem;">' + text + '</div>'
                      );
                    }
                  }



                  // return "hi"
                }
                else if (chartproperties.datalabelStyle === 'change') {
                  let text =
                    pointWithMetric.y1 != null
                      ? pointWithMetric.y +
                      (chartproperties.dataLabelFormat ? '%' : '') +
                      ' ' +
                      `<span span style="font-size: 80%;color:` +
                      (chartproperties.darkTheme ? 'white' : 'black') +
                      `">(` + `${pointWithMetric.cov} )</span>`
                      : 'NA';
                  pointWithMetric.tooltip = text;
                  return (
                    '<span style:"color:' + textcolor + ';">' + text + '</span>'
                  );
                } else if (
                  chartproperties.datalabelStyle === 'significance + changeVs'
                ) {
                  const upwardTriangle = '\u25B2';
                  const downwardTriangle = '\u25BC';
                  let sig = Number(pointWithMetric.significance);
                  let s =
                    sig > 0 ? upwardTriangle : sig < 0 ? downwardTriangle : '';
                  let sigcolor = sig > 0 ? 'green' : sig < 0 ? 'red' : '';
                  let text =
                    pointWithMetric.y1 != null
                      ? pointWithMetric.y +
                      (chartproperties.dataLabelFormat ? '%' : '') +
                      ' ' +
                      `<span span style="font-size: 80%;color:` +
                      (chartproperties.darkTheme ? 'white' : 'black') +
                      `">(` +
                      (Number(pointWithMetric.cov) > 0 ? '+' : '') +
                      `${pointWithMetric.cov} )</span>` +
                      '<span style="color:' +
                      sigcolor +
                      ';">' +
                      s +
                      '</span>'
                      : 'NA';
                  pointWithMetric.tooltip = text;
                  return (
                    '<span style:"color:' + textcolor + ';">' + text + '</span>'
                  );
                } else if (chartproperties.datalabelStyle === 'significance') {
                  const upwardTriangle = '\u25B2';
                  const downwardTriangle = '\u25BC';
                  let sig = Number(pointWithMetric.significance);
                  let s =
                    sig > 0 ? upwardTriangle : sig < 0 ? downwardTriangle : '';
                  let sigcolor = sig > 0 ? 'green' : sig < 0 ? 'red' : '';

                  let text =
                    pointWithMetric.y1 != null
                      ? pointWithMetric.y +
                      (chartproperties.dataLabelFormat ? '%' : '') +
                      '<span style="color:' +
                      sigcolor +
                      ';">' +
                      s +
                      '</span>'
                      : 'NA';
                  pointWithMetric.tooltip = text;
                  return (
                    '<span style:"color:' + textcolor + ';">' + text + '</span>'
                  );
                } else if (chartproperties.datalabelStyle === 'ls') {
                  let text =
                    Number(pointWithMetric.samplesize) > samplesizeconstant
                      ? pointWithMetric.y1 == null
                        ? 'NA'
                        : pointWithMetric.y +
                        (chartproperties.dataLabelFormat ? '%' : '')
                      : 'LS';
                  pointWithMetric.tooltip = text;
                  return (
                    '<span>' +
                    pointWithMetric.name +
                    '</span> <span>' +
                    text +
                    '</span> ' +
                    '<span style="opacity: 0.5"></span>'
                  );
                } else if (chartproperties.datalabelStyle == 'significance2') {
                  const upwardTriangle = '\u25B2';
                  const downwardTriangle = '\u25BC';
                  let text =
                    pointWithMetric.y1 != null
                      ? this.y + (chartproperties.dataLabelFormat ? '%' : '')
                      : 'NA';
                  let changeText = pointWithMetric.cov;
                  let sig = Number(pointWithMetric.significance);
                  let sig1 = Number(pointWithMetric.significance2);
                  let sColor =
                    Number(sig) > 0 ? 'green' : Number(sig) < 0 ? 'red' : '';
                  let s =
                    Number(sig) > 0
                      ? upwardTriangle
                      : Number(sig) < 0
                        ? downwardTriangle
                        : '';
                  let changeColor =
                    sig1 < 0
                      ? 'red'
                      : sig1 > 0
                        ? 'green'
                        : chartproperties.darkTheme
                          ? 'white'
                          : 'black';
                  if (Number(changeText) > 0) {
                    changeText = '+' + changeText;
                  }
                  pointWithMetric.tooltip = text;
                  return (
                    '<span>' +
                    text +
                    (pointWithMetric.y1 != null && changeText
                      ? '&nbsp<span style="color:' +
                      ';"> ' +
                      '<span style="font-size: 80%; color:' +
                      changeColor +
                      ';">(' +
                      changeText +
                      ')</span> &nbsp' +
                      '<span style="color:' +
                      sColor +
                      ';">' +
                      s +
                      '</span>'
                      : '') +
                    '</span>'
                  );
                }
              },
            },
          },
        },
        series: this.seriesdata,

        credits: {
          enabled: false,
        },
        exporting: {
          enabled: false,
        },
      }
      Highcharts.chart('chart-container' + this.id, options);
    }
  }
  applycustomization(event: any, item: string) {
    //choose the appropriate customization
    this.uniquechartservice.applycustomization(event, item, this.chartproperties)
    this.plotChart(
      'chart-container' + this.id,
      this.jsondata['data'],
      this.chartproperties
    );
  }
  userselectedproperties() {
    this.jsondata['data'] = this.arrangeArrayDescending(this.jsondata['data']);
    this.jsondata['properties'][0] = this.chartproperties;
    return JSON.stringify(this.jsondata).toString();
  }
}
